import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Leaf, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState("Processing authentication...");

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get("session_id");

        if (!sessionId) {
          setStatus("No session found");
          toast.error("Authentication failed: No session ID");
          navigate("/login");
          return;
        }

        setStatus("Verifying with server...");

        // Exchange session_id for session_token via backend
        const response = await fetch(`${API}/auth/google/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.detail || "Authentication failed");
        }

        const data = await response.json();
        
        // Store user in localStorage for AuthContext
        localStorage.setItem("ecodecide_user", JSON.stringify(data.user));
        
        // Store JWT token for API requests (hybrid auth)
        if (data.token) {
          localStorage.setItem("ecodecide_token", data.token);
        }
        
        setStatus("Success! Redirecting...");
        toast.success("Connexion Google réussie !");

        // Check if user needs to set organization
        if (data.user.organization === "Non définie") {
          navigate("/setup-organization", { state: { user: data.user } });
        } else {
          navigate("/dashboard", { state: { user: data.user } });
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        setStatus("Authentication failed");
        toast.error(error.message || "Échec de l'authentification Google");
        navigate("/login");
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-6">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-primary flex items-center justify-center">
          <Leaf className="w-10 h-10 text-primary-foreground" />
        </div>
        <div className="space-y-2">
          <Loader2 className="w-8 h-8 mx-auto text-primary animate-spin" />
          <p className="text-lg text-foreground font-medium">{status}</p>
          <p className="text-sm text-muted-foreground">Veuillez patienter...</p>
        </div>
      </div>
    </div>
  );
}
